import script from "./ImportDashboardModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ImportDashboardModal.vue?vue&type=script&setup=true&lang=js"

import "./ImportDashboardModal.vue?vue&type=style&index=0&id=2f66c312&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f66c312"]])

export default __exports__